<template>
  <div class="zero-state-wrapper">
    <img :src="imageSrc" class="zero-state-asset" alt="Zero State" />
    <div>
      <h3>{{ title }}</h3>
      <p>{{ message }}</p>
      <button v-if="buttonTitle != undefined" class="btn btn-small btn-border" @click="eventHandler()">
        <unicon name="plus"></unicon>
        <span>{{ buttonTitle }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ZeroState",
  data() {
    return {
      imageSrc: null,
    };
  },
  props: {
    imageURL: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    horizontal: {
      type: Boolean,
      required: false,
    },
    buttonTitle: {
      type: String,
      required: false,
    },
  },
  created() {
    if (process.env.VUE_APP_MODE == "development")
      this.imageSrc = "/assets/images/zerostate/" + this.imageURL;
    else
      this.imageSrc =
        process.env.VUE_APP_AWS_ASSETS_URL + "/images/zerostate/" + this.imageURL;
  },
  methods: {
    eventHandler() {
      this.$emit('eventHandler');
    },
  },
};
</script>

<style scoped lang="scss">
.zero-state-wrapper {
  text-align: center;

  .btn {
    margin: auto;
  }
}

.zero-state-asset {
  display: block;
  width: 18.5rem;
  mix-blend-mode: multiply;
  margin: .5rem auto 1.5rem;
}

.zero-state-wrapper h3 {
  font-size: $largeFontSize;
  margin-bottom: 0.3rem;
}

.zero-state-wrapper p {
  color: $greyColor;
  margin-bottom: 1rem;
}
</style>